export default __webpack_public_path__ + "static/media/biryani-by-kilo-login.341aef64.jpg";